<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1 style="padding-bottom:40px;">Acknowledgement</h1>
<p>Thanks to the hard work and dedication of all the staff at the production team at Austin Macauley for turning this story into a book for children.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?87e11160